import React from 'react';
import RowDeleteButton from '../../components/ActionButtons/RowDeleteButton';
import RowEditButton from '../../components/ActionButtons/RowEditButton';
import RowRunButton from '../../components/ActionButtons/RowRunButton';

/**
 * props:
 * - data
 * - onEditClick
 * - onRunClick
 * - onDeleteClick
 */
function WithdrawTemplateRow(props) {

    return (
        <tr className="align-middle">
            <td>
                {props.data.coin}
            </td>
            <td>
                {props.data.name}
            </td>
            <td>
                <span className='fw-normal'>{props.data.amount}</span>
            </td>
            <td>
                <RowEditButton id={props.data.id} title='Editar este Modelo de Saque' modalId='modalWithdrawTemplate' onClick={props.onEditClick} />
                <RowRunButton id={props.data.id} title='Sacar Agora' onClick={props.onRunClick} />
                <RowDeleteButton id={props.data.id} title='Excluir este Modelo de Saque' onClick={props.onDeleteClick} />
            </td>
        </tr>
    );
}

export default WithdrawTemplateRow;